document.addEventListener('click', (event) => {
  const cookiePreferencesLink = event.target.closest(
    'a[href$="#ustawienia-plikow-cookies"]'
  );

  if (!cookiePreferencesLink || !window.privacyBanner?.showPreferences) return;

  event.preventDefault();
  window.privacyBanner.showPreferences();
});
